import { render, staticRenderFns } from "./Story2.vue?vue&type=template&id=94665026&scoped=true&"
import script from "./Story2.vue?vue&type=script&lang=js&"
export * from "./Story2.vue?vue&type=script&lang=js&"
import style0 from "./Story2.vue?vue&type=style&index=0&id=94665026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94665026",
  null
  
)

export default component.exports